const setNoOfProjects = (payload) => {
  return {
    type: "setNoOfProjects",
    payload,
  };
};

export default setNoOfProjects;
